export const resultsConstants = {
  HOME_RESULTS_REQUEST: 'HOME_RESULTS_REQUEST',
  HOME_RESULTS_SUCCESS: 'HOME_RESULTS_SUCCESS',
  HOME_RESULTS_FAILURE: 'HOME_RESULTS_FAILURE'
};
